import { readableUrl } from '@wix/communities-blog-client-common';

export const getPathWithoutSectionUrl = ({
  route,
  topology,
  shouldNavigateToFeed,
}: {
  route: string;
  topology: { sectionUrl?: string; postPageSectionUrl?: string; baseUrl?: string };
  shouldNavigateToFeed?: boolean;
  useReadableUrl?: boolean;
}) => {
  const { sectionUrl, postPageSectionUrl, baseUrl } = topology;
  const readableBaseUrl = readableUrl(baseUrl as string);
  const currentSectionUrl = shouldNavigateToFeed
    ? readableBaseUrl === route
      ? readableBaseUrl
      : readableUrl(sectionUrl as string)
    : readableUrl(postPageSectionUrl as string);
  return route.startsWith(currentSectionUrl) ? route.slice(currentSectionUrl.length) : route;
};
